import React from 'react';

function Testimonials() {
  const commitments = [
    {
      id: 1,
      icon: "✓",
      title: "Satisfaction Garantie",
      description: "100% Satisfait ou Remboursé",
      text: "Nous ne considérons le projet terminé que lorsque vous êtes pleinement satisfait. Support gratuit inclus pour garantir votre réussite."
    },
    {
      id: 2,
      icon: "⚡",
      title: "Délais Respectés",
      description: "Livraison Rapide et Fiable",
      text: "Sites vitrine livrés en 7-10 jours, e-commerce en 2-3 semaines. Transparence totale sur l'avancement de votre projet à chaque étape."
    },
    {
      id: 3,
      icon: "🛡️",
      title: "Support Réactif",
      description: "Toujours Disponible",
      text: "Réponse sous 24h garantie. Maintenance préventive, corrections de bugs pendant 6 mois, et assistance technique illimitée."
    }
  ];

  return (
    <section id="temoignages" className="py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 fade-in">
          <div className="badge mb-4">NOTRE ENGAGEMENT</div>
          <h2 className="text-4xl sm:text-5xl font-bold mb-4 font-['Poppins'] text-white">
            Pourquoi nous choisir?
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Des garanties concrètes pour votre tranquillité d'esprit
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {commitments.map(commitment => (
            <div key={commitment.id} className="glass rounded-2xl p-8 card-hover fade-in">
              <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#0066ff] to-[#00d4ff] rounded-2xl mb-6 text-3xl">
                {commitment.icon}
              </div>
              <h3 className="text-2xl font-bold text-white mb-2 font-['Poppins']">
                {commitment.title}
              </h3>
              <p className="text-[#00d4ff] font-semibold mb-4 text-sm">
                {commitment.description}
              </p>
              <p className="text-gray-300 leading-relaxed">
                {commitment.text}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-16 fade-in">
          <p className="text-gray-400 mb-6 text-lg">Prêt à démarrer votre projet?</p>
          <a href="#contact" className="inline-block btn-shine bg-[#0066ff] hover:bg-[#0052cc] text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all transform hover:-translate-y-1">
            Demander un Devis Gratuit
          </a>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;